// Export selectors
export const selectCurrentUser = (state) => state.auth.userDetails
export const selectCurrentUserFullName = (state) => `${state.auth?.userDetails?.firstName} ${state.auth?.userDetails?.lastName}`;
export const selectCurrentUserEmail = (state) => state.auth?.userDetails?.email;
export const selectIsUserLoginCompleted = (state) => state.auth.isUserLoggedIn
export const selectCurrentAccessToken = (state) => state.auth.accessToken
export const selectCurrentIDToken = (state) => state.auth.idToken
export const selectCurrentRefreshToken = (state) => state.auth.refreshToken
export const selectCognitoUsername = (state) => state.auth.cognitoUsername
export const selectCognitoEmailAddress = (state) =>
    state.auth.cognitoEmailAddress
export const selectIsAuthCodeRequired = (state) => state.auth.isAuthCodeRequired
export const selectIsSendAuthCodeInProgress = (state) => state.auth.sendAuthCodeInProgress
export const selectIsSubmitAuthCodeInProgress = (state) => state.auth.submitAuthCodeInProgress
export const selectWorkStarted = (state) => state.auth.isWorkStarted
export const selectWorkSuccess = (state) => state.auth.isWorkSuccess
export const selectWorkFailed = (state) => state.auth.isWorkFailure
export const selectWorkErrorMessage = (state) => state.auth.workErrorMsg
export const selectWorkProgressMessage = (state) => state.auth.workProgressMsg
export const selectCreateAccountEmailAddress = (state) =>
    state.auth.createAccountEmailAddress
export const selectIsAccountCreationCompleted = (state) =>
    state.auth.isAccountCreationCompleted
